module.exports = "/images/smart-way-img.svg?a330b32a5414e82590d25f0ae40eaa0b";